import styled, { css } from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import Check from '@panel/commons/assets/icons/checkOrange.svg';
import CheckVA from '@panel/commons/assets/icons/checkBlueVamx.svg';
import CheckCM from '@panel/commons/assets/icons/checkBlueCM.svg';
import CheckUB from '@panel/commons/assets/icons/checkGreenUB.svg';
import PlayIcon from '@panel/commons/assets/icons/play.svg';
import PowerIcon from '@panel/commons/assets/icons/powerButton.svg';
import ArchiveIcon from '@panel/commons/assets/icons/archive.svg';
import FiltroIcon from '@panel/commons/assets/icons/Filtro.svg';
import ResponsibleIcon from '@panel/commons/assets/icons/Responsible.svg';
import moreIcon from '@panel/commons/assets/icons/moreIcon.svg';
import { getColor } from '@panel/commons/core/themev3';

const siteId = process.env.REACT_APP_BUILD_SITE;

const SearchBar = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 8px 8px 24px;
  width: 100%;
  height: 64px;
  border-radius: 8px;
  background-color: ${select('lightGray')};
  margin-bottom: 16px;
  position: relative;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      margin-bottom: 46px;
    `}
`;

const SearchBarLeftSide = styled.div`
  display: flex;
  align-items: center;
  .checkBox-container {
    margin-right: ${({ device }) => (device === 'tablet' ? '20px' : '26px')};
  }
  .quantity-label {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        position: absolute;
        bottom: -36px;
        left: 0px;
      `}
  }
`;

const GeneralCheckDropdown = styled.div`
  height: 48px;
  width: ${({ width }) => `${width}px`};
  border-radius: 8px;
  border: 1px solid ${select('midLightGray')};
  background-color: ${select('white')};
  border-color: ${props => props.active && getColor('primary')};
  display: inline-flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  ${withQuery.lg.down()} {
    justify-self: flex-end;
  }
  > span {
    margin-left: 21px;
    font-size: 14px;
    cursor: pointer;
  }
  > button {
    background-image: ${props => (!props.active ? `url(${ChevronDown})` : `url(${ChevronUp})`)};
    margin-right: 21px;
  }
  position: relative;
  > div {
    &:last-of-type {
      display: ${props => !props.active && 'none'};
    }
  }
`;

const DropdownButton = styled.button`
  width: 12px;
  height: 12px;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 4px;
  cursor: pointer;
`;

const DropDownCheckList = styled.div`
  min-width: ${props => props.size && props.size};
  border-radius: 8px;
  border: 1px solid ${select('midLightGray')};
  background-color: ${select('white')};
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 9;
  top: 52px;
  padding: 10px 0px;
  cursor: auto;
  > div {
    padding-left: ${props => props.smallPadding && '16px'} !important;
  }
  .separator {
    height: 0.5px;
    width: calc(100% - 32px);
    background-color: ${select('middleGray')};
    margin: 8px 16px 12px;
  }
  .sortOnlineFirst {
    height: 32px;
    font-family: 'Hind';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-right: 16px;
  }
`;

const DropdownOption = styled.div`
  font-family: 'Hind';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding-right: 16px;
  cursor: pointer;
  :last-of-type {
    margin-bottom: 6px;
  }
  :hover {
    background-color: ${select('lightGray')};
  }
  &.DROPDOWN-OPTIONS-TITLE {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 25px;
  }
  &.SEARCHBAR-DROP-SELECTED {
    &:after {
      margin-left: 8px;
      content: ${() => {
        if (siteId === 'CMBR') return `url(${CheckCM})`;
        if (siteId === 'UBPE') return `url(${CheckUB})`;
        if (siteId === 'VAMX') return `url(${CheckVA})`;
        return `url(${Check})`;
      }};
      width: 16px;
      height: 16px;
      vertical-align: sub;
    }
  }
`;

const SearchBarRightSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${withQuery.lg.down()} {
    width: 100%;
  }
  .search-container {
    width: 320px;
    margin-right: 12px;
    ${withQuery.lg.down()} {
      width: 191px;
    }
  }
  .filter-button-tablet {
    height: 48px;
    width: 48px;
    margin-left: 10px;
    border-radius: 8px;
    border: 1px solid ${select('midLightGray')};
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    > div {
      background-image: ${`url(${FiltroIcon})`};
      background-size: cover;
      height: 28px;
      width: 28px;
    }
  }
`;

const BulkActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: ${({ position }) => position};
  margin-right: 16px;
`;

const BulkActionText = styled.div`
  font-family: Hind;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
`;

const BulkActionIcons = {
  finish: PowerIcon,
  publish: PlayIcon,
  archive: ArchiveIcon,
  responsible: ResponsibleIcon,
  moreActions: moreIcon
};

const isDesktop = css`
  ${({ device }) =>
    device === 'desktop' &&
    css`
      height: 36px;
      width: 36px;
    `}
`;

const BulkActionIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${isDesktop};
  cursor: pointer;
  :hover {
    background-color: ${select('grayMedium')};
  }
`;

const BulkActionIcon = styled.div`
  background-image: ${({ action }) => `url(${BulkActionIcons[action]})`};
  width: ${({ width }) => width || '26px'};
  height: ${({ height }) => height || '26px'};
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export {
  SearchBar,
  SearchBarLeftSide,
  SearchBarRightSide,
  GeneralCheckDropdown,
  DropdownButton,
  DropDownCheckList,
  DropdownOption,
  BulkActionContainer,
  BulkActionText,
  BulkActionIconContainer,
  BulkActionIcon
};
